export default __webpack_public_path__ + "static/media/iconPinBlack.3e0472da.svg";